import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { FireExtinguishersViewModel } from "./FireExtinguishersViewModel";
import { SHBox } from "../../../../../Components/Box";
import { RadioAuditView } from "./EndOfWeekView";
import { FireExitModel } from "./FireExitModel";
import { Uploader } from "../../../../../Components/Uploader/Uploader";
import { SectionSplitter } from "../../../../../Components/Form/SectionSplitter";
import { FireExitViewModel } from "./FireExitViewModel";
import { EndOfWeekViewModel } from "./EndOfWeekViewModel";
import { uniqueId } from "lodash-es";
import { IconButton, Typography } from "@material-ui/core";
import { FirePointViewModel } from "./FirePointViewModel";
import { SpillKitViewModel } from "./SpillKitViewModel";
import SystemUpdateTwoToneIcon from "@material-ui/icons/SystemUpdateTwoTone";
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import { AuditDocumentModel } from "../AuditDocument";
import { DarwinInput } from "../../../../../Globals/Styles/Control/DarwinInput";
interface Props {
    index: number;
    spillKitViewModel: SpillKitViewModel;
    endOfWeekViewModel: EndOfWeekViewModel;
}
export const SpillKitView: React.FC<Props> = observer((props: Props) => {
    const { spillKitViewModel, endOfWeekViewModel } = props;

    return (
        <>
            <SHBox mt={2} key={uniqueId()}>
                <Typography variant={"h4"}>Spill Kit {props.index + 1}:</Typography>
                <SHBox grid dc={"262px"} mt={2} mb={2}>
                    <DarwinInput<SpillKitViewModel>
                        type="text"
                        label="Location:"
                        placeholder="Please add"
                        validateOnBlur={false}
                        viewModel={spillKitViewModel}
                        fieldName={"location"}
                        shrink={true}
                        maxLength={4096}
                        editMode={endOfWeekViewModel.editable}
                    />
                </SHBox>
                <SHBox grid dc={"2fr 1fr"} mt={1}>
                    <RadioAuditView
                        title={"Correct signage in place"}
                        value={() => spillKitViewModel.getValue("correctSignageInPlace")}
                        validationMessage={() => spillKitViewModel.getError("correctSignageInPlace")}
                        onChange={(e) => spillKitViewModel.radioChanged(e, "correctSignageInPlace", endOfWeekViewModel.editable)}
                        canExecute={endOfWeekViewModel.editable}
                    />
                    <SHBox dcs={"2"} showIf={spillKitViewModel.getValue("correctSignageInPlace") === "no"}>
                        <DarwinInput<FireExitViewModel>
                            type="text"
                            label="Please give more details"
                            multiLine={true}
                            validateOnBlur={false}
                            viewModel={spillKitViewModel}
                            fieldName={"correctSignageInPlaceDetail"}
                            shrink={true}
                            maxLength={4096}
                            editMode={endOfWeekViewModel.editable}
                        />
                    </SHBox>
                    <RadioAuditView
                        title={"All contents in place"}
                        value={() => spillKitViewModel.getValue("allContentsInPlace")}
                        validationMessage={() => spillKitViewModel.getError("allContentsInPlace")}
                        onChange={(e) => spillKitViewModel.radioChanged(e, "allContentsInPlace", endOfWeekViewModel.editable)}
                        canExecute={endOfWeekViewModel.editable}
                    />
                    <SHBox dcs={"2"} showIf={spillKitViewModel.getValue("allContentsInPlace") === "no"}>
                        <DarwinInput<FireExitViewModel>
                            type="text"
                            label="Please give more details"
                            multiLine={true}
                            validateOnBlur={false}
                            viewModel={spillKitViewModel}
                            fieldName={"allContentsInPlaceDetail"}
                            shrink={true}
                            maxLength={4096}
                            editMode={endOfWeekViewModel.editable}
                        />
                    </SHBox>
                    <RadioAuditView
                        title={"All contents in good condition"}
                        value={() => spillKitViewModel.getValue("allContentsInGoodCondition")}
                        validationMessage={() => spillKitViewModel.getError("allContentsInGoodCondition")}
                        onChange={(e) => spillKitViewModel.radioChanged(e, "allContentsInGoodCondition", endOfWeekViewModel.editable)}
                        canExecute={endOfWeekViewModel.editable}
                    />
                    <SHBox dcs={"2"} showIf={spillKitViewModel.getValue("allContentsInGoodCondition") === "no"}>
                        <DarwinInput<FireExitViewModel>
                            type="text"
                            label="Please give more details"
                            multiLine={true}
                            validateOnBlur={false}
                            viewModel={spillKitViewModel}
                            fieldName={"allContentsInGoodConditionDetail"}
                            shrink={true}
                            maxLength={4096}
                            editMode={endOfWeekViewModel.editable}
                        />
                    </SHBox>
                    <SHBox grid dc={"1fr"}>
                        {" "}
                        <SHBox showIf={endOfWeekViewModel.editable}>
                            <Uploader
                                handleSelectFile={(e: React.ChangeEvent<HTMLInputElement>) => endOfWeekViewModel.fileChange(e, spillKitViewModel.model.auditDocuments)}
                                isFormDisabled={endOfWeekViewModel.IsLoading}
                                label="Photos(s)"
                            />
                            <Typography variant={"h5"} color={"error"}>
                                {spillKitViewModel.getError("auditDocuments")}
                            </Typography>
                        </SHBox>
                        <div className="uploadedFile">
                            {spillKitViewModel.model.auditDocuments.map((item: AuditDocumentModel, index: number) => {
                                return (
                                    <div className="uploadedFile-box" key={uniqueId()}>
                                        <div className="uploadedFile-heading">
                                            <IconButton onClick={() => endOfWeekViewModel.DownloadFile(item.url, item.fileName)}>
                                                <SystemUpdateTwoToneIcon />
                                            </IconButton>
                                            <h3>{item.fileName}</h3>
                                        </div>
                                        <IconButton onClick={() => item.deleteDocument()} disabled={false}>
                                            <DeleteOutlinedIcon />
                                        </IconButton>
                                    </div>
                                );
                            })}
                        </div>
                    </SHBox>
                </SHBox>
                <SectionSplitter />
            </SHBox>
        </>
    );
});
